import { createReducer, on } from '@ngrx/store';
import { ITypeExpenses } from 'src/app/shared/interfaces/expenses/itypeExpenses';
import { loadTypeExpenses, loadTypeExpensesSuccess } from './type-expenses.actions';

export interface ITypeExpensesState {
  lista: ITypeExpenses[];
  isLoading: boolean
}

const initialState: ITypeExpensesState = {
  lista: [],
  isLoading: false
};

export const typeExpensesReducer = createReducer(
  initialState,
  on(loadTypeExpenses, (state) => ({
    ...state,
    isLoading: true
  }))
  ,
  on(loadTypeExpensesSuccess, (state, { lista }) => ({
    ...state,
    lista: [...lista],
    isLoading: false
  }))
);
